module.exports = __webpack_public_path__ + "static/media/landing-benefit-license.a65aff4c.svg";